import { render, staticRenderFns } from "./sofyre-ingredients.vue?vue&type=template&id=cb93d6c0&scoped=true&"
import script from "./sofyre-ingredients.vue?vue&type=script&lang=js&"
export * from "./sofyre-ingredients.vue?vue&type=script&lang=js&"
import style0 from "./sofyre-ingredients.vue?vue&type=style&index=0&id=cb93d6c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb93d6c0",
  null
  
)

export default component.exports